export default __webpack_public_path__ + "static/media/logo_eximbank_pc.b1e86bdb.png";